import { add } from "date-fns";

import { BookingAvailability } from "@/constants/Booking";
import { Text } from "@/ui/core";
import { Box } from "@/ui/layout";
import EmptyListContent from "@/ui/layout/list/EmptyListContent";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface BookingAvailabilityTimeSlot {
  endDateTime: string;
  startDateTime: string;
}

interface UseBookingAvailabilityArgs {
  initialDate: Date;
  weekOffset: number;
}

const useBookingAvailabilityTimeSlots = ({
  initialDate,
  weekOffset,
}: UseBookingAvailabilityArgs): BookingAvailabilityTimeSlot => {
  const isInitialRange = weekOffset === 0;
  const startDateTime = add(initialDate, {
    // If it's the initial range, we want to start at the next hour
    hours: isInitialRange ? 1 : 0,
    weeks: weekOffset,
  }).toISOString();
  const endDateTime = add(initialDate, {
    weeks: BookingAvailability.searchRangeInWeeks + weekOffset,
  }).toISOString();

  return {
    endDateTime,
    startDateTime,
  };
};
const NoAvailabilityContent = ({ testID }: ViewWithTestID) => {
  return (
    <EmptyListContent
      paragraphs={[
        "We're sorry, it looks like that Equip provider doesn't have any availability within the next two months.",
        "Please message your provider directly to find a time",
      ]}
      testID={testID}
      title="No availability found"
    />
  );
};

const MaxAvailabilityRangeCard = ({ testID }: ViewWithTestID) => {
  return (
    <Box
      backgroundColor={ColorToken.NeutralBackgroundSecondary}
      borderRadius={12}
      padding={18}
    >
      <Text
        color={ColorToken.NeutralPrimary}
        testID={joinTestIDs(testID, "max-availability")}
        variant="caption"
      >
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        Equip doesn't support bookings more than two months in advance
      </Text>
    </Box>
  );
};

export {
  MaxAvailabilityRangeCard,
  NoAvailabilityContent,
  useBookingAvailabilityTimeSlots,
};
